import type { ReactNode } from 'react'

export function PageContent({ children }: { children: ReactNode }) {
  return <div className="p-6">{children}</div>
}
